import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "captcha-warp"
};
export default /*#__PURE__*/_defineComponent({
  emits: ["success"],

  setup(__props, {
    expose,
    emit
  }) {
    // 返回结果
    // ret         Int       验证结果，0：验证成功。2：用户主动关闭验证码。
    // ticket      String    验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
    // CaptchaAppId       String    验证码应用ID。
    // bizState    Any       自定义透传参数。
    // randstr     String    本次验证的随机串，请求后台接口时需带上。
    // res（用户主动关闭验证码）= {ret: 2, ticket: null}
    // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
    // res（客户端出现异常错误 仍返回可用票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
    const CaptchaEl = ref();
    expose({
      show: () => {
        CaptchaEl.value.click();
      }
    });
    onMounted(() => {
      ;

      window.captchaCb = res => {
        console.log(res);

        if (res.ret === 0) {
          emit('success', res);
        }
      };
    });
    onUnmounted(() => {
      ;
      window.__CaptchaExists__ = null;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        id: "CaptchaEl",
        ref_key: "CaptchaEl",
        ref: CaptchaEl,
        "data-appid": "2036785952",
        "data-cbfn": "captchaCb",
        "data-module": "0",
        type: "primary",
        style: {
          "display": "none"
        }
      }, null, 512), (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
        src: "https://captcha.253.com/Captcha.js"
      }))]);
    };
  }

});